"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyCustomDatePicker = exports.DEFAULT_DATE_FORMAT = void 0;

const react_1 = __importDefault(require("react"));

const x_date_pickers_1 = require("@mui/x-date-pickers/");

const AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");

const moment_1 = __importDefault(require("moment"));

const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");

const material_1 = require("@mui/material");

exports.DEFAULT_DATE_FORMAT = "MM/DD/YYYY";

const SskyCustomDatePicker = props => {
  const format = props.format || exports.DEFAULT_DATE_FORMAT;
  let datePickerProps = {
    value: props.value,
    toolbarPlaceholder: moment_1.default.utc().format(exports.DEFAULT_DATE_FORMAT),
    onChange: props.onChange,
    inputFormat: format,
    disabled: props.disabled
  };

  if (props.minDate) {
    Object.assign(datePickerProps, {
      minDate: props.minDate,
      minDateMessage: props.minDateMessage || `Value must be ${props.minDate.format(format)} or later`
    });
  }

  if (props.maxDate) {
    Object.assign(datePickerProps, {
      maxDate: props.maxDate,
      maxDateMessage: props.maxDateMessage || `Value must be ${props.maxDate.format(format)} or earlier`
    });
  }

  if (props.onDateValidityChange) {
    Object.assign(datePickerProps, {
      onError: (error, value) => {
        props.onDateValidityChange(!error);
      }
    });
  }

  return react_1.default.createElement(x_date_pickers_1.LocalizationProvider, {
    dateAdapter: AdapterMoment_1.AdapterMoment
  }, react_1.default.createElement(DatePicker_1.DatePicker, Object.assign({
    "data-testid": props.dataTestId || `testId-${props.id}`,
    renderInput: params => react_1.default.createElement(material_1.TextField, Object.assign({}, params, {
      variant: "standard",
      label: props.label || "",
      error: props.error,
      id: props.id
    }))
  }, datePickerProps)));
};

exports.SskyCustomDatePicker = SskyCustomDatePicker;
exports.default = react_1.default.memo(SskyCustomDatePicker);